import * as React from 'react';
import { UserContext } from '../context/userContext';
import { conversationService } from '../api';

import { useNavigate } from 'react-router-dom';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { Action } from './Action';
import { BookmarkConversation, ShareConversation } from '../molecules';

interface Props {
  uid?: string;
}

export const ConversationCommonActionsIcons: React.FC<Props> = ({
  uid = '',
}) => {
  const { loggedIn } = React.useContext(UserContext);
  const {
    conversationDelete,
    getConversation,
    addBookmarkConversation,
    removeBookmarkConversation,
  } = conversationService();
  const navigate = useNavigate();

  if (!uid) {
    return null;
  }

  const { actions, is_bookmarked } = getConversation(uid);

  const deleteConversation = () => {
    conversationDelete
      .mutateAsync({
        uid,
      })
      .catch(() => {})
      .finally(() => {
        navigate('/');
      });
  };

  const handleBookmarkConversation = (isBookmarked: boolean) => {
    console.log('isBookmarked: ', isBookmarked);
    if (isBookmarked) {
      addBookmarkConversation({ uid });
    } else {
      removeBookmarkConversation({ uid });
    }
  };

  return loggedIn ? (
    <>
      {actions?.includes('bookmark:conversation') && (
        <BookmarkConversation
          isBookmarked={!!is_bookmarked}
          onBookmark={handleBookmarkConversation}
        />
      )}
      {actions?.includes('share:conversation') && (
        <ShareConversation conversationId={uid} />
      )}
      {actions?.includes('delete:conversation') && (
        <Action
          actionLabel={'Delete'}
          icon={<DeleteForeverIcon />}
          confirmText="Are you sure you want to delete this Conversation?"
          confirmTitle="Deleting Conversation"
          onAction={deleteConversation}
        />
      )}
    </>
  ) : null;
};
